module.exports = __webpack_public_path__ + "static/media/ad.69be5cc0.jpg";